<template>
  <div class="page">
    <div class="page-content">
  		<page-nav-bar currentServiceName="MoneyRoad" v-bind:subNavTitle="subNavTitle"></page-nav-bar>
      <div class="layoutTop"/>
      <div class="container-fluid">

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <f7-list v-if="this.capsule === 'draft-edit'" class="draftTitle">
              <f7-list-item>
                <f7-label class="paymentsRequestSubOption formLabel formLabelPayment"><span class="color-red">* </span>Draft name</f7-label>
                <f7-input class="paymentsRequestSubOption" placeholder="Draft name" type="text" v-model="draftName"></f7-input>
              </f7-list-item>
            </f7-list>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default">

              <div class="panel-heading">
                <div class="showLargeScreenOnly">
                  <h4 class="content-block labelAccordionForm">
                    <img src='../../../assets/static/images/icons/inbox_out.png' class="formIcon"/>
                    New Modular Loan Request
                  </h4>
                </div>
                <div class="showSmallScreenOnly">
                  <h6 class="content-block labelAccordionForm creationFormTitle">
                    <img src='../../../assets/static/images/icons/inbox_out.png' class="formIcon"/>
                    New Modular Loan Request
                  </h6>
                </div>
              </div>
              <ul>
                <form-accordion :title="$t('common.formsSubTitle.item_info', {itemname: $t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))})">
                  <!-- TLV 24/08/2020 : On désactive la sélection de contact pour la démo de GCollect -->
                  <!-- <div class="form-group row">
                    <div class="col-sm-4" v-bind:class="colorBottomButton">
                      <a href="/directDebit/contactDebtorList/">
                        <span href="#" class="button button-round button-inner-color">
                            {{ $t('sent.select_cntct_btn',
                              {contacttype: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                        </span>
                      </a>
                    </div>
                    <div class="col-sm-4 offset-sm-4" v-if="isOcrActive === true" v-bind:class="colorBottomButton">
                      <input class="item-input hiddenElementAllSize rib-file-input" @change="executeOCROnRIB" type="file"/>
                      <f7-button
                        class="button-round button-inner-color attachmentButton buttonAccordionForm"
                        @click="importRIB($event)" >
                        {{ $t('sent.import_RIB_btn',
                          {contacttype: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                      </f7-button>
                    </div>
                  </div> -->

                  <div class="row">
                    <form-write-group-label-input :isMandatory="true"
                      :idLabel="$t(common.nme)" :placeholderValue="$t('common.debtor_name')"
                      v-model="debtorName">
                    </form-write-group-label-input>
                    <form-write-group-label-input :isMandatory="true"
                      :idLabel="$t('common.idtfr')" :placeholderValue="$t('common.debtor_email')"
                      v-model="debtorEmail">
                    </form-write-group-label-input>
                  </div>
                  <div class="row">
                    <form-write-group-label-input :isMandatory="true"
                      :idLabel="$t('bank_accounts.bank_account_singular')" :placeholderValue="$t('common.debtor_iban')"
                      v-model="debtorBank">
                    </form-write-group-label-input>
                  </div>
                </form-accordion>
              </ul>
              <hr/>
              <ul>
                <form-accordion title="common.formsSubTitle.my_acc_info">
                  <div class="form-group row showSmallScreenOnly">
                    <label class="col-sm-8 col-form-label labelAccordionForm" v-bind:class="{redFont: creditorColor}">
                      <span class="color-red">* </span>
                      My Account
                    </label>
                    <div class="col-sm-4 showSmallScreenOnly" v-bind:class="colorBottomButton">
                      <div @click="accountPicker($event)" class="button button-round button-inner-color">
                        Select
                      </div>
                    </div>
                  </div>
                  <div class="form-group row showSmallScreenOnly">
                    <div class="col-sm-12">
                      <input class="form-control" id="account-input" type="text" v-model="creditorBankName" placeholder="Choose account" readonly></input>
                    </div>
                  </div>
                  <div class="row">
                    <div class="form-group col-md-6">
                      <label>
                        {{ $t('bank_accounts.bank_account_singular_small') }}
                        <span class="color-red">* </span>
                      </label>
                      <select class="form-control showLargeScreenOnly" id="sel2" readonly v-model="creditorBank">
                        <option value="">{{ $t('creation_forms.slct_an_acc') }}</option>
                        <option v-for="bankAccount in bankAccounts" :key="bankAccount.id" :value="bankAccount.iban">
                          {{bankAccount.name}} ({{ $engine.bankAccounts.getCurrency(bankAccount.zoneCode) }})
                        </option>
                      </select>
                    </div>
                  </div>
                </form-accordion>
              </ul>
              <hr/>
              <ul>
                <form-accordion hasDatePicker title="MODULAR LOAN DETAILS">
                  <div class="row">
                      <form-write-group-label-input :isMandatory="true"
                        :idLabel="$t('common.rsn')" :placeholderValue="$t('common.rsn')"
                        v-model="remittanceInformation">
                      </form-write-group-label-input>
                      <form-write-group-label-input :isMandatory="true"
                        :idLabel="$t('common.amnt')" :placeholderValue="$t('common.amnt')"
                        v-model="amount" inputType="number">
                      </form-write-group-label-input>
                  </div>
                  <div class="row">
                      <form-write-group-label-input :isMandatory="true"
                        :idLabel="$t('common.date_label')" :placeholderValue="$t('common.slct_date')"
                        v-model="depositExecutionDate" inputType="date">
                      </form-write-group-label-input>
                      <form-write-group-label-input :isMandatory="true"
                        :idLabel="$t('common.deposit_amnt_label')" :placeholderValue="$t('common.deposit_amnt_label')"
                        v-model="deposit" inputType="number">
                      </form-write-group-label-input>
                  </div>
                </form-accordion>
              </ul>
              <hr/>
                <ul>
                  <form-accordion open :title="$t(this.$engine.services.getAttachmentName(this.$engine.user.currentService.id))">
                    <div class="form-group row">
                      <div class="col-sm-6" v-bind:class="colorBottomButton">
                          <f7-button
                            class="button-round button-inner-color attachmentButton buttonAccordionForm longword-word"
                            style="margin-bottom: 1rem;"
                            @click="openImportAttachmentInvoice()">
                            {{ $t('common.import_item',
                                {itemname: this.$i18n.t(this.$engine.services.getAttachmentName(this.$engine.user.currentService.id)) }) }}
                          </f7-button>
                      </div>
                      <div class="col-sm-6">
                        <input class="form-control inputAccordionForm" type="text"
                          readonly
                          v-model="attachmentNameLabel" id="application-file-input"></input>
                        <input class="item-input hiddenElementAllSize local-file-input" @change="onFileChange"type="file"/>
                        <input class="hiddenElementAllSize" type="text"></input>
                        <input class="hiddenElementAllSize" type="text" id="recommendation-list-input"></input>
                      </div>
                    </div>
                    <!-- <div class="form-group row" v-if="(typeof attachmentName) !== 'undefined' && attachmentName !== ''">
                      <label class="col-4 col-sm-2 col-form-label labelAccordionForm">
                        Reference
                      </label>
                      <div class="col-8 col-sm-10">
                        <input
                          class="form-control inputAccordionForm"
                          placeholder="Reference"
                          type="text"
                          v-model="attachmentReference">
                        </input>
                      </div>
                    </div> -->
                    <!-- Téléchargements possibles sur les drafts -->
                    <div v-if="false" class=" form-group row" :class="colorBottomButton">
                      <div v-if="isSmartphone" class="col-md-4 offset-md-2">
                        <f7-button v-if="hasAttachment" class="button-round button-inner-color buttonAccordionForm attachmentButton" @click="view(attachmentId)">View Attachment</f7-button>
                      </div>
                      <div v-if="!isSmartphone" class="col-md-4 offset-md-2">
                        <f7-button v-if="hasAttachment" class="button-round button-inner-color attachmentButton" @click="view(attachmentId)">Download Attachment</f7-button> <!--Download-->
                      </div>
                      <div class="col-md-4">
                        <f7-button class="button-round button-inner-color attachmentButton" @click="clearAttachement()" v-if="(typeof attachmentName) !== 'undefined' && attachmentName !== ''">Clear</f7-button>
                      </div>
                    </div>
                    <div v-if="false && hasAttachment" class="row">
                      <div v-if="isSmartphone" class="col-md-4 offset-md-2">
                        <f7-button class="button-round button-inner-color buttonAccordionForm attachmentButton" @click="view(attachmentId)">View Attachment</f7-button>
                      </div>
                      <div v-if="!isSmartphone" class="col-md-4 offset-md-2">
                        <f7-button class="button-round button-inner-color buttonAccordionForm attachmentButton" @click="view(attachmentId)">Download Attachment</f7-button> <!--Download-->
                      </div>
                    </div>
                  </form-accordion>
                </ul>
              <hr v-if="rulesEnabled"/>
              <ul v-if="rulesEnabled">
                <form-accordion :title="$t('regles_metier.titles.rules')">
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <b-form-checkbox
                        @change="getAllInstallmentRules()"
                        v-model="hasRegles"
                        :value="true"
                        :unchecked-value="false">
                          Add installment rules
                        </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <b-form-checkbox
                        v-model="negotiationAllowed"
                        :value="true"
                        :unchecked-value="false">
                          {{ $t('regles_metier.allow_edit_installments_rules') }}
                        </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6">
                      <div class="form-group" v-show="hasRegles">
                        <label>{{ $t('regles_metier.select_installment_template') }}</label>
                        <select class="form-control" @change="setInstallmentRules($event)">
                          <option selected :value="0">{{ $t('regles_metier.none_installment_template') }}</option>
                          <!-- <option :value="0">Manual</option> -->
                          <option v-for="rule in allRules" :value="rule.idReglesMetier" :key="rule.idReglesMetier">{{`${rule.nom} – [installments: ${rule.nbEcheances.min} - ${rule.nbEcheances.max}]`}}</option>
                        </select>
                      </div>
                    </b-col>
                  </b-row>
                  <regles-form :hideInfo="true" :hideInterests="true" v-if="hasRegles" :value="reglesMetier" @input="reglesMetier = $event" v-on:echeance-changed="echeanceChanged($event)"/>
                </form-accordion>
              </ul>
              <hr v-if="rulesEnabled && reglesMetier.idReglesMetier && hasRegles"/>
              <ul v-if="rulesEnabled && reglesMetier.idReglesMetier && hasRegles">
                <form-accordion :title="$t('regles_metier.titles.rules_details')">
                  <regles-details v-if="reglesMetier.idReglesMetier && hasRegles" :reglesMetier="reglesMetier"/>
                  <p v-else>{{$t('regles_metier.details.no_rules')}}</p>
                </form-accordion>
              </ul>
              <hr>
              <ul>
                <form-accordion hasDatePicker :title="$t('regles_metier.titles.installments')">
                  <b-row>
                    <b-col sm="6">
                      <b-form-group>
                        <b-form-checkbox
                        v-model="hasInstallments"
                        :value="true"
                        :unchecked-value="false"
                        :disabled="reglesMetier.nbEcheances.min > reglesMetier.nbEcheances.max">
                          {{ $t('regles_metier.add_installments') }}
                        </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                    <b-col sm="6">
                      <b-form-group>
                        <b-form-checkbox
                        v-model="modificationInstallmentsAllowed"
                        :value="true"
                        :unchecked-value="false">
                          {{ $t('regles_metier.edit_installments') }}
                        </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col sm="6" v-if="hasInstallments">
                      <div class="form-group">
                        <label>{{ $t('regles_metier.select_nb_installments') }}</label>
                        <select v-if="hasRegles && reglesMetier.idReglesMetier" :disabled="!hasInstallments" class="form-control" v-model="payNumber">
                          <option v-for="nb in $R.range(parseInt(reglesMetier.nbEcheances.min), parseInt(reglesMetier.nbEcheances.max)+1)"
                                  :value="nb">
                                  {{nb}}
                          </option>
                        </select>
                        <b-form-input v-else v-model="payNumber" :disabled="!hasInstallments" type="number" min="1" max="24"/>
                      </div>
                    </b-col>
                  </b-row>
                  <echeancier
                    v-if="hasInstallments"
                    :numPay="payNumber"
                    :min="borneInf"
                    :amount="amount"
                    :ccy="ccy"
                    :deposit="deposit"
                    v-model="multPmts"/>
                </form-accordion>
              </ul>
              </div>
            </div>
          </div>
        <div class="row justify-content-start" v-bind:class="colorBottomButton">
          <div class="col-md-3 offset-md-1">
            <!-- Bouton "Save request" disabled pour GCollect -->
            <!-- <button round
            v-if="clearance === '1' | clearance === '2'"
            v-bind:class="savePosition"
            class="button-action firstButtonMarginTop"
              @click="getNameDraft">
              <i class="icon fa fa-save"></i>
              Save Request
            </button> -->
          </div>
          <div class="col-md-3 offset-md-4">
            <button round
            v-if="clearance === '1' | clearance === '2'"
            class="button-action firstButtonMarginTop"
             @click="sendDirectDebit">
              <i class="icon fa fa-paper-plane"></i>
              Send Request
            </button>
          </div>
        </div>
      </div>

    <div class="toolbarPageBottomBlank"></div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as JsPDF from 'jspdf'
// import {get} from '@/helpers/api'
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import {validateIBAN} from '@/helpers/validator'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import datePickerMixin from '@/mixins/datePickerMixin'
// import PaymentsSentboxPage from '@/pages/services/payments/CMSendboxPage.vue'
// import {getPayments} from '@/helpers/payments'
import {loadPage} from '@/helpers/routing'
import FormAccordion from '@/components/common/FormAccordion.vue'
import ReglesForm from '@/pages/reglesEcheancier/EcheancierReglesForm.vue'
import ReglesDetails from '@/pages/reglesEcheancier/EcheancierReglesDetails.vue'
import Echeancier from '@/pages/requests/EcheancierForm.vue'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  mixins: [datePickerMixin],
  name: 'writePayments',
  props: ['subNavTitle', 'capsule', 'saveMessage'],
  components: {
    JsPDF,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'form-accordion': FormAccordion,
    'regles-form': ReglesForm,
    'regles-details': ReglesDetails,
    'echeancier': Echeancier,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      isSmartphone: false,
      debtorName: '',
      debtorBank: '',
      debtorEmail: '',
      creditorBank: '',
      creditorBankName: '',
      remittanceInformation: '',
      depositExecutionDate: '',
      amount: '',
      deposit: '',
      modificationAccepted: false,
      attachement: '',
      attachmentName: '',
      attachementReference: '',
      attachementId: '',
      loadingFile: false,
      isOcrActive: false,
      fromCloud: false,
      bankAccounts: [],
      contacts: [],
      contactSelectionList: [],
      contactsObject: {},
      cloudFiles: [],
      ImmPmtAccepted: false,
      cloudDocsPicker: '',
      contactsPicker: '',
      accountsPicker: '',
      selected: '',
      selectedDebtor: {},
      enteredDebtors: [],
      sendPaymentsClicked: false,
      directPayments: '0',
      sumColor: 'red',
      multPmts: [],
      payNumber: 1,
      ccy: '€',
      clearance: '',
      draftName: '',
      idDraft: '',
      reglesMetier: this.$engine.reglesMetier.defaultData(),
      hasRegles: false,
      allRules: [],
      hasInstallments: false,
      negotiationAllowed: this.$engine.settings.directDebit.get().defaultNegotiationAllowed === '1',
      modificationInstallmentsAllowed: this.$engine.settings.directDebit.get().defaultModificationInstallmentsAllowed === '1'
    }
  },
  computed: {
    attachmentNameLabel () {
      if (this.attachmentName === '') {
        return this.$i18n.t('common.slct_item', {itemname: this.$i18n.t(this.$engine.services.getAttachmentName(this.$engine.user.currentService.id))})
      } else {
        return this.attachmentName
      }
    },
    debtorListColor () {
      // return Object.keys(this.selectedDebtors).length === 0 && this.enteredDebtors.length === 0 && this.sendPaymentsClicked
      return this.selected === '' && this.sendPaymentsClicked
    },
    creditorColor () {
      return this.creditorBankName === '' && this.sendPaymentsClicked
    },
    remittanceInformationColor () {
      return this.remittanceInformation === '' && this.sendPaymentsClicked
    },
    depositExecutionDateColor () {
      return (this.depositExecutionDate === '' || this.depositExecutionDate === 'Invalid date') && this.sendPaymentsClicked
    },
    amountColor () {
      return this.amount === '' && this.sendPaymentsClicked
    },
    savePosition: function () {
      return {
        leftfav: this.clearance === '1' | this.clearance === '2'
      }
    },
    sum: function () {
      let sum = 0
      for (let i = 0; i < this.multPmts.length; i++) {
        sum += (this.multPmts[i].amount === '' || this.multPmts[i].amount == null) ? 0 : parseFloat(this.multPmts[i].amount)
      }
      sum += (this.deposit == null || this.deposit === '') ? 0 : parseFloat(this.deposit) // On ajoute le deposit, correspondant a l'echeance 0
      return sum
    },
    borneInf () {
      if (this.hasRegles) {
        return this.reglesMetier.nbEcheances.min
      } else {
        return 1
      }
    },
    rulesEnabled () {
      return this.$engine.settings.directDebit.get().enableInstallmentRules === '1'
    }
  },
  mounted () {
    this.$engine.services.payments.contactDebtorList = []

    // Guangze: get default modificationAccepted value
    this.modificationAccepted = this.$engine.settings.directDebit.get().defaultNegotiationAllowed === '1'
    if (this.modificationAccepted) {
      this.Dom7('.checkboxModificationAccepted').prop('checked', true)
    }
  },
  created () {
    let that = this

    if (that.$engine.services.directDebit.filter.smartphoneStorage) {
      that.isSmartphone = true
    }

    if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
      this.isSmartphone = true
    }

    if (this.$engine.settings.directDebit.get().ocrActivation === '1') {
      that.isOcrActive = true
    }
    that.multPmts = []
    // that.multPmts.push({date: that.$settings.clickedMessage.reqstdExecDt, amount: that.$settings.clickedMessage.amt})
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.$on('refresh-contact-payments', (data) => {
      this.debtorName = data.debtorName
      this.debtorBank = data.debtorBank
      this.debtorEmail = data.debtorEmail
    })
    this.enteredDebtors = this.$engine.services.payments.debtorList
    // TODO : selected
    // this.selected = this.$engine.services.payments.contactDebtorList
    this.selected = ''
    this.$engine.services.payments.contactDebtorList = []
    this.$engine.services.payments.contactGroupsSelected = []
    // this.contacts = this.$settings.currentAccount.contacts
    this.contacts = this.$engine.contacts.get()
    for (var i = 0; i < that.contacts.length; i++) {
      that.contactsObject[that.contacts[i].id] = that.contacts[i]
    }
    this.setContacts()
    this.$bus.$on('refresh-debtor-contact-list', (data) => {
      that.selected = data
      that.selectedDebtor = {}
      that.selectedDebtor = that.contactsObject[this.selected]

      that.debtorName = that.selectedDebtor.name
      that.debtorEmail = that.selectedDebtor.identifier
      that.debtorBank = that.selectedDebtor.iban
    })
    this.bankAccounts = this.$engine.bankAccounts.get()
    this.cloudFiles = this.$engine.attachments.get()
    this.loadingFile = false
    this.fromCloud = false
    this.depositExecutionDate = moment().format('YYYY-MM-DD')
    this.creditorBank = ''
    this.creditorBankName = ''
    that.attahmentName = 'File'
    if (typeof (this.$settings.preChargedFile) !== 'undefined') {
      if (this.$settings.preChargedFile.fromCloudList === true) {
        this.fromCloud = true
        this.attachementId = this.$settings.preChargedFile.id
        this.attachmentName = this.$settings.preChargedFile.name
        this.attachement = this.$settings.preChargedFile.data
        this.attachementReference = this.$settings.preChargedFile.reference
        this.amount = this.$settings.preChargedFile.amount
        this.depositExecutionDate = this.$settings.preChargedFile.depositExecutionDate
        this.debtorName = this.$settings.preChargedFile.debtorName
        this.debtorEmail = this.$settings.preChargedFile.debtorEmail
        this.debtorBank = this.$settings.preChargedFile.debtorBankAccount
        this.remittanceInformation = this.$settings.preChargedFile.remittanceInformation
        if (this.debtorName !== '' && this.debtorEmail === '') {
          for (i = 0; i < this.contacts.length; i++) {
            if (this.contacts[i].name === this.$settings.preChargedFile.debtorName) {
              that.debtorName = this.contacts[i].name
              that.debtorBank = this.contacts[i].iban
              that.debtorEmail = this.contacts[i].identifier
            }
          }
        }
      }
    }
    this.$settings.preChargedFile = undefined

    if (typeof (this.$settings.preChargedDraft) !== 'undefined') {
      if (this.$settings.preChargedDraft.AttachmentId !== '') {
        this.attachementId = this.$settings.preChargedDraft.AttachmentId
      }
      if (this.$settings.preChargedDraft.attachmentName !== '') {
        this.attachmentName = this.$settings.preChargedDraft.attachmentName
      }
      if (this.$settings.preChargedDraft.Attachment !== '' && this.$settings.preChargedDraft.Attachment !== '$NotFound') {
        this.attachement = this.$settings.preChargedDraft.Attachment
      }
      if (this.$settings.preChargedDraft.AttachmentReference !== '') {
        this.attachementReference = this.$settings.preChargedDraft.AttachmentReference
      }
      if (this.$settings.preChargedDraft.CreditorBankAccount !== '') {
        this.creditorBank = this.$settings.preChargedDraft.CreditorBankAccount
      }
      if (this.$settings.preChargedDraft.RemittanceInformation !== '') {
        this.remittanceInformation = this.$settings.preChargedDraft.RemittanceInformation
      }
      if (this.$settings.preChargedDraft.RequestedExecutionDate !== '') { // DEPOSIT exec date
        this.depositExecutionDate = this.$settings.preChargedDraft.RequestedExecutionDate
      }
      if (this.$settings.preChargedDraft.Amount !== '') {
        this.amount = this.$settings.preChargedDraft.Amount
      }
      if (this.$settings.preChargedDraft.Deposit !== '') {
        this.deposit = this.$settings.preChargedDraft.Deposit
      }
      if (this.$settings.preChargedDraft.ModificationAccepted === 'true') {
        this.modificationAccepted = true
      } else if (this.$settings.preChargedDraft.ModificationAccepted === 'false') {
        this.modificationAccepted = false
      }
      if (this.$settings.preChargedDraft.draftName !== '') {
        this.draftName = this.$settings.preChargedDraft.draftName
      }
      if (typeof (this.$settings.preChargedDraft.multPmts) !== 'undefined' && this.$settings.preChargedDraft.multPmts !== '') {
        this.multPmts = this.$settings.preChargedDraft.multPmts
        for (i = 0; i < this.$settings.preChargedDraft.multPmts.length; i++) {
          this.multPmts[i] = this.$settings.preChargedDraft.multPmts[i]
        }
        this.payNumber = this.multPmts.length
      }
      this.idDraft = this.$settings.preChargedDraft.idDraft
      this.debtorName = this.$settings.preChargedDraft.DebtorName
      this.debtorEmail = this.$settings.preChargedDraft.DebtorEmail
      this.debtorBank = this.$settings.preChargedDraft.DebtorBankAccount
      if (this.debtorName !== '' && this.debtorEmail === '') {
        for (i = 0; i < this.contacts.length; i++) {
          if (this.contacts[i].name === this.$settings.preChargedDraft.DebtorName) {
            that.debtorName = this.contacts[i].name
            that.debtorBank = this.contacts[i].iban
            that.debtorEmail = this.contacts[i].identifier
          }
        }
      }
      for (i = 0; i < this.contacts.length; i++) {
        if (
          this.contacts[i].name === this.debtorName &&
          this.contacts[i].identifier === this.debtorEmail &&
          this.contacts[i].iban === this.debtorBank
        ) {
          this.selectedDebtor = this.contacts[i]
        }
      }
      for (let i = 0; i < this.bankAccounts.length; i++) {
        if (this.bankAccounts[i].iban === this.$settings.preChargedDraft.CreditorBankAccount) {
          this.creditorBankName = this.bankAccounts[i].name
        }
      }
    }
    this.$settings.preChargedDraft = undefined

    let contactsMap = this.contacts.map(function (obj) {
      let rObj = {}
      rObj[obj.label] = obj
      return rObj
    })
    let contactsMapObj = Object.assign({}, ...contactsMap)
    this.contactsPicker = this.$f7.picker({
      input: '#bookContacts',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: Object.keys(contactsMapObj)
        }
      ],
      onClose: function (p) {
        // var data = []
        that.debtorName = contactsMapObj[p.value].name
        that.debtorBank = contactsMapObj[p.value].iban
        that.debtorEmail = contactsMapObj[p.value].identifier
        that.contacts = contactsMapObj[p.value]
      }
    })
    let ibansMap = this.bankAccounts.map(function (obj) {
      let rObj = {}
      rObj[obj.name] = obj.iban
      return rObj
    })
    let ibansMapObj = Object.assign({}, ...ibansMap)
    this.accountsPicker = this.$f7.picker({
      input: '#account-input',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: Object.keys(ibansMapObj)
        }
      ],
      onClose: function (p) {
        that.creditorBank = ibansMapObj[p.value]
        that.creditorBankName = p.value
      },
      onOpen: function (p) {
        // that.creditorBankName = p.value
      }
    })
    let filesMap = this.cloudFiles.map(function (obj) {
      let rObj = {}
      rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
      return rObj
    })
    let filesMapObj = Object.assign({}, ...filesMap)
    let values = []
    if (Object.keys(filesMapObj).length > 0) {
      values = Object.keys(filesMapObj)
    } else {
      values = ['Nothing found']
    }
    this.cloudDocsPicker = this.$f7.picker({
      input: '#application-file-input',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: values
        }
      ],
      onClose: function (p) {
        if (Object.keys(filesMapObj).length > 0) {
          if (filesMapObj[p.value].id !== that.attachementId) {
            that.attachementId = filesMapObj[p.value].id
            that.cloudFileSel()
          }
        }
      },
      onOpen: function (p) {
        if (Object.keys(filesMapObj).length > 0) {
          that.attachmentName = p.value
        }
      }
    })
    this.clearance = this.$engine.user.get().clearance['Direct Debit']
  },
  beforeDestroy () {
    this.attachmentName = ''
    this.attachment = ''
    this.debtorName = ''
    this.debtorBank = ''
    this.creditorBank = ''
    this.debtorEmail = ''
    this.remittanceInformation = ''
    this.depositExecutionDate = ''
    this.amount = ''
    this.attachementReference = ''
    this.modificationAccepted = false
    this.attachementId = ''
    this.loadingFile = ''
    this.fromCloud = ''
    this.bankAccounts = ''
    this.contacts = []
    this.cloudFiles = []
    this.ImmPmtAccepted = false
    this.cloudDocsPicker = ''
    this.accountsPicker = ''
    this.clearance = ''
    this.draftName = ''
    this.idDraft = ''

    let attachmentObj = {
      fromCloudList: false,
      id: 0,
      name: '',
      data: '',
      amount: 0,
      reference: '',
      debtorName: '',
      executionDate: ''
    }
    this.$engine.settings.set({preChargedFile: attachmentObj})
  },
  watch: {
    loadingFile (val) {
      if (val) {
        this.$f7.showPreloader('Loading File')
      } else {
        this.$f7.hidePreloader()
      }
    },
    payNumber: function (val) {
      if (this.multPmts.length > 0) {
        if (this.hasRegles && this.reglesMetier.idReglesMetier) {
          if (val < this.reglesMetier.nbEcheances.min || val > this.reglesMetier.nbEcheances.max) {
            this.payNumber = this.reglesMetier.nbEcheances.min
          }
        } else {
          if (val < 1) {
            this.payNumber = 1
          }
        }
      }
    },
    hasRegles: function (val) {
      // Si hasRegles devient false :
      if (!val) {
        // On charge les regles metier par defaut
        this.reglesMetier = this.$engine.reglesMetier.defaultData()
        // On réinitialise le sélecteur de règles métier
        const diffAmount = function (a, b) { return parseFloat(a.montant) - parseFloat(b.montant) }
        this.allRules = this.$R.sort(diffAmount, this.reglesMetier)
      }
    },
    'reglesMetier.idReglesMetier': function (val) {
      // Si des règles métier sont sélectionnées
      if (val !== undefined) {
        if (this.payNumber < this.reglesMetier.nbEcheances.min) {
          // Si le nombre d'échéances est < au nombre MIN autorisé --> payNumber = nb.MIN
          this.payNumber = this.reglesMetier.nbEcheances.min
        } else if (this.payNumber > this.reglesMetier.nbEcheances.max) {
          // Si le nombre d'échéances est > au nombre MAX autorisé --> payNumber = nb.MAX
          this.payNumber = this.reglesMetier.nbEcheances.max
        }
      }
    }
  },
  methods: {
    changeSwitchModificationAccepted (obj) {
      this.modificationAccepted = obj.target.checked
    },
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('card-header')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
          that.Dom7($event.target).find('i').transform('rotate(90deg)')
        } else {
          that.Dom7($event.target).next().hide()
          that.Dom7($event.target).find('i').transform('rotate(0deg)')
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
          that.Dom7($event.target).parent().find('i').transform('rotate(90deg)')
        } else {
          that.Dom7($event.target).parent().next().hide()
          that.Dom7($event.target).parent().find('i').transform('rotate(0deg)')
        }
      }
      // that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top - that.$$('.page-content').offset().top + that.$$('.page-content').scrollTop() + 300, 400)
      that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top + that.$$(that.$$('.page-content')[that.$$('.page-content').length - 1]).offset().top - 96, 400)
    },
    setContacts: function () {
      var contactList = {}
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var firstLetter = this.$engine.contacts.get(j).identifier.substr(0, 1).toUpperCase()
        if (!contactList.hasOwnProperty(firstLetter)) {
          contactList[firstLetter] = []
        }
        contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, identifier: this.$engine.contacts.get(j).identifier, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id})
        contactList[firstLetter].sort()
      }
      this.contactSelectionList = this.orderKeys(contactList)
    },
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 500000) {
        this.createImage(files[0])
        this.attachmentName = files[0].name
        this.Dom7(this.Dom7('.fileNameDisplay')[this.Dom7('.fileNameDisplay').length - 1]).val(this.attachmentName)
        // this.Dom7('.fileNameDisplay').text(this.attachmentName)
      } else {
        this.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 500Kb', 'Maximum file size exceeded')
      }
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    switched () {
      this.fromCloud = !this.fromCloud
      this.attachmentName = ''
      this.attachement = ''
      this.attachementId = ''
    },
    cloudFileSel () {
      const that = this
      this.loadingFile = true
      this.$engine.attachments.download(that.attachementId.toString())
        .then(response => {
          that.attachmentName = response.data.document_name
          that.attachement = response.data.document_data
          that.loadingFile = false
          that.attachementReference = response.data.internal_reference
          that.Dom7('.fileNameDisplay').text(that.attachmentName)
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    createImage (file) {
      var that = this
      var reader = new FileReader()
      reader.onload = (e) => {
        that.attachement = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.attachement = ''
    },
    // convertDateFormat () {
    //   this.executionDate = moment(this.executionDate).format('YYYY-MM-DD')
    // },
    getNameDraft () {
      var namedraft = ''
      let that = this
      if (this.capsule === 'draft-create' || this.capsule === 'direct-debit-create') {
        this.$f7.modal({
          title: 'Please enter a name for your draft',
          // text: 'Enter a name of draft',
          afterText: '<div class="item-input"><input class="inputnamedraft" type="text"></div>',
          buttons: [
            {
              text: 'Cancel',
              color: 'red',
              onClick: function () {
              }
            },
            {
              text: 'Save',
              onClick: function () {
                let namedraft = that.Dom7('.inputnamedraft').val()
                that.draftName = namedraft
                that.SaveInDraft(namedraft)
              }
            }
          ]
        })
      } else {
        this.SaveInDraft(namedraft)
      }
    },
    importRIB ($event) {
      this.Dom7(this.Dom7('.rib-file-input')[this.Dom7('.rib-file-input').length - 1]).click()
    },
    executeOCROnRIB (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 50000000) {
        let that = this
        var reader = new FileReader()
        reader.onload = (e) => {
          that.executeOCR('RIB', e.target.result)
        }
        return reader.readAsDataURL(files[0])
      } else {
        this.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 50Mo', 'Maximum file size exceeded')
      }
    },
    /** @author ERI- TLV
    * @date 27/03/2020
    * @brief méthode qui execute l'OCR à partir de l'Order transmis en paramètre
    *     et qui affiche les données retournées sur l'IHM
    * @param filetype may be: RIB, Invoice, Order
    * @param file est l'image chiffrée en base64
    */
    executeOCR (filetype, file) {
      let that = this
      // key : IHM reception parameter, value : OCR returned data
      let exchangeData = {
        'RIB': {
          debtorBank: 'iban',
          debtorName: 'name'
        }
      }
      that.$f7.showPreloader(that.$i18n.t('sent.ocr_loading'))
      return that.$engine.services.ocr(
        that.$engine.user.get().id,
        '',
        file,
        'jpeg',
        'scan',
        filetype
      ).then(response => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.ocr_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        response = response.data
        // Pour l'instant l'OCR ne marche qu'avec des IBAN
        this.debtorZoneCode = this.$engine.bankAccounts.getZoneData('EU')
        for (var key in exchangeData[filetype]) {
          if (response[exchangeData[filetype][key]] === '$Error' ||
              response[exchangeData[filetype][key]] === '$NotFound') {
            response[exchangeData[filetype][key]] = ''
          }
          that[key] = response[exchangeData[filetype][key]]
        }
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
        console.log(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
      })
    },
    SaveInDraft (namedraft) {
      let that = this
      this.depositExecutionDate = moment(this.depositExecutionDate).format('YYYY-MM-DD')
      this.multPmts.forEach(function (element) {
        element.date = moment(element.date).format('YYYY-MM-DD')
      })
      let draftArray = []

      if (that.capsule === 'draft-edit') {
        draftArray.push({
          'idDraft': that.idDraft,
          'idAccount': this.$engine.user.get().id,
          'DraftName': this.draftName,
          'CreditorName': this.$engine.user.get().name,
          'CreditorBankAccount': this.creditorBank,
          'CreditorIdentifier': this.$engine.user.get().identifier,
          'DebtorName': this.debtorName,
          'DebtorBankAccount': this.debtorBank,
          'DebtorIdentifier': this.debtorEmail,
          'StartingDate': this.depositExecutionDate,
          'FirstAmount': this.deposit,
          'CollectionAmount': this.amount,
          'Reason': this.remittanceInformation,
          'Currency': this.ccy,
          'attachmentName': that.attachmentName,
          'AttachmentReference': that.attachementReference,
          'Attachment': that.attachement,
          'multPmts': this.multPmts
        })
        this.$engine.ddDrafts.update(draftArray[0])
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/directDebit/draft/', force: false, ignoreCache: false})
            }, 2000)
          }
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
      } else { // capsule=='draft-create' or capsule=='direct-debit-create'
        let requestLoad = {
          'idAccount': this.$engine.user.get().id,
          'DraftName': this.draftName,
          'CreditorName': this.$engine.user.get().name,
          'CreditorBankAccount': this.creditorBank,
          'CreditorIdentifier': this.$engine.user.get().identifier,
          'DebtorName': this.debtorName,
          'DebtorBankAccount': this.debtorBank,
          'DebtorIdentifier': this.debtorEmail,
          'StartingDate': this.depositExecutionDate,
          'FirstAmount': this.deposit,
          'CollectionAmount': this.amount,
          'Reason': this.remittanceInformation,
          'Currency': this.ccy,
          'attachmentName': that.attachmentName,
          'AttachmentReference': that.attachementReference,
          'Attachment': that.attachement,
          'multPmts': this.multPmts
        }
        that.$engine.ddDrafts.create(requestLoad)
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            if (that.capsule === 'draft-create' || that.capsule === 'direct-debit-create') {
              setTimeout(function () {
                that.$f7.closeModal()
                loadPage(that, {url: '/directDebit/draft/', force: false, ignoreCache: false})
              }, 2000)
            } else {
              setTimeout(function () {
                that.$f7.closeModal()
                that.Dom7('.attachmentTaphold').removeClass('listItemSelected')
              }, 2000)
            }
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    sendDirectDebit: function () {
      let that = this

      let requestAlertText = 'Sending Modular Loan'
      let responseAlertText = 'Modular Loan Sent'

      this.sendPaymentsClicked = true
      let returnFlag = false
      let requestDetailsBlockFlag = false
      let debtorFlag = false
      let creidtorFlag = false
      let remittanceInformationFlag = false
      let depositExecutionDateFlag = false
      let amountFlag = false
      let depositDateFlag = false
      let depositFlag = false
      let multPmtFlag = false
      let invalidDateFlag = false // Si les dates d'un ML envoyé sont antérieures à aujourd'hui

      // Vérification sur le débiteur (nom, compte bancaire [IBAN], email)
      if (Object.keys(this.selectedDebtor).length === 0 && !this.debtorName && !this.debtorBank && !this.debtorEmail) {
        that.$$('.recipientBlock').show()
        returnFlag = true
        debtorFlag = true
      }

      //  Vérification sur le compte bancaire [IBAN] du créditeur
      if (this.creditorBank === '') {
        that.$$('.myAccountBlock').show()
        returnFlag = true
        creidtorFlag = true
      }

      // Vérification sur la raison
      if (this.remittanceInformation === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        remittanceInformationFlag = true
      }

      // Vérification sur la date d'exécution du dépôt
      if (this.depositExecutionDate === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        depositExecutionDateFlag = true
      }

      // Vérification sur le montant de la transaction
      if (!this.amount) {
        requestDetailsBlockFlag = true
        returnFlag = true
        amountFlag = true
      }

      let today = moment().format('YYYY-MM-DD')
      if (moment(this.depositExecutionDate).format('YYYY-MM-DD') < today) {
        requestDetailsBlockFlag = true
        returnFlag = true
        depositDateFlag = true
      }

      if (!this.deposit) {
        requestDetailsBlockFlag = true
        returnFlag = true
        depositFlag = true
      }

      if (this.hasInstallments) {
        for (let i = 0; i < this.multPmts.length; i++) {
          // TLV 14/10/2019 : si un montant d'installment vaut 0, c'est comme s'il était vide
          if (this.multPmts[i].date === '' || this.multPmts[i].amount === '' || this.multPmts[i].amount === 0 || this.multPmts[i].amount == null) {
            requestDetailsBlockFlag = true
            returnFlag = true
            multPmtFlag = true
          }
          if (moment(this.multPmts[i].date).format('YYYY-MM-DD') < moment(this.depositExecutionDate).format('YYYY-MM-DD')) {
            invalidDateFlag = true
            returnFlag = true
          }
        }
      } else if (!this.modificationInstallmentsAllowed) {
        requestDetailsBlockFlag = true
        returnFlag = true
        multPmtFlag = true
      }

      if (requestDetailsBlockFlag) {
        that.$$('.requestDetailsBlock').show()
      }

      // Vérification de non contradition entre delais entre deux echeances et delais total [regles metier]
      const intervalleTotalSec = this.intervalleToSec(this.installmentRules.interval)
      const delaisTotalSec = this.intervalleToSec(this.installmentRules.totalPeriod)
      if (intervalleTotalSec > 0 && delaisTotalSec > 0 && intervalleTotalSec > delaisTotalSec) {
        this.$f7.alert('Time between installments should not be superior to time until last installment', 'Invalid')
        return
      }

      if (debtorFlag) {
        this.$f7.alert('', 'Debtor missing')
      } else if (creidtorFlag) {
        this.$f7.alert('', 'Creditor missing')
      } else if (remittanceInformationFlag) {
        this.$f7.alert('', 'Reason missing')
      } else if (depositExecutionDateFlag) {
        this.$f7.alert('', 'Execution date missing')
      } else if (amountFlag) {
        this.$f7.alert('', 'Amount missing')
      } else if (depositDateFlag) {
        this.$f7.alert('Deposit date must be today or after', 'Deposit Date')
      } else if (depositFlag) {
        this.$f7.alert('', 'Deposit amount missing')
      } else if (multPmtFlag) {
        this.$f7.alert('', 'Installment missing')
      } else if (invalidDateFlag) {
        this.$f7.alert('', this.$t('errors.past_installment_date'))
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && !depositExecutionDateFlag && !amountFlag && !depositFlag && !multPmtFlag && !invalidDateFlag) {
      } else {
        this.$f7.alert('', 'Data missing')
      }

      if (returnFlag) {
        return
      }

      // TLV 14/10/2019 : Les dates d'installment doivent toutes être différentes. Sinon, le formulaire n'est pas envoyé
      if (this.hasInstallments) {
        let uniqueExecutionDate = []
        uniqueExecutionDate.push(this.depositExecutionDate)
        let flagUniqueExecutionDate = true
        for (let i = 0; i < this.multPmts.length; i++) {
          if (uniqueExecutionDate.includes(this.multPmts[i].date)) {
            flagUniqueExecutionDate = false
          } else {
            uniqueExecutionDate.push(this.multPmts[i].date)
          }
        }
        if (flagUniqueExecutionDate === false) {
          this.$f7.alert('Installment date should be all different', 'Invalid')
          return
        }
      }

      // Vérification que la somme des échéances et du dépôt ne soit pas supérieur au montant de la transaction
      if (this.sum > this.amount) {
        this.$f7.alert('Installments exceed total amount', 'Invalid Installments')
        return
      }

      const sortByDate = this.$R.sortBy(this.$R.prop('date'))
      const multPmtsSorted = sortByDate(this.multPmts)

      this.depositExecutionDate = moment(this.depositExecutionDate).format('YYYY-MM-DD')

      this.$f7.showPreloader(requestAlertText)

      that.$engine.services.directDebit
      .create({
        creditorIdentifier: this.$engine.user.get().identifier,
        creditorName: this.$engine.user.get().name,
        creditorBankAccount: that.creditorBank,
        debtorIdentifier: that.debtorEmail,
        debtorName: that.debtorName,
        debtorBankAccount: that.debtorBank,
        reason: that.remittanceInformation,
        deposit: that.deposit,
        depositExecutionDate: that.depositExecutionDate,
        amount: that.amount,
        currency: 'EUR',
        multiExecutions: multPmtsSorted,
        attachmentName: that.attachmentName,
        attachmentReference: that.attachementReference,
        attachmentData: that.attachement,
        hasRegles: (that.hasRegles ? '1' : '0'),
        hasInstallments: (that.hasInstallments ? '1' : '0'),
        initiator: 'creditor',
        reglesMetier: that.reglesMetier,
        negotiation_allowed: (that.negotiationAllowed ? '1' : '0'),
        modification_installments_allowed: (that.modificationInstallmentsAllowed ? '1' : '0')
      })
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          if (that.capsule === 'draft-edit') {
            that.$engine.ddDrafts.del(that.idDraft)
            .then(response => {
              that.$f7.hidePreloader()
              this.$f7.modal({
                title: responseAlertText,
                text: '<i class="icon fa fa-check"></i>'
              })
              this.$engine.services.directDebit.debtorList = []
              this.$engine.services.directDebit.contactDebtorList = []
              setTimeout(function () {
                that.$f7.closeModal()
                loadPage(that, {url: '/directDebit/sendbox/'})
              }, 2000)
            })
          } else {
            that.$f7.hidePreloader()
            this.$f7.modal({
              title: responseAlertText,
              text: '<i class="icon fa fa-check"></i>'
            })
            this.$engine.services.directDebit.debtorList = []
            this.$engine.services.directDebit.contactDebtorList = []
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/directDebit/sendbox/'})
            }, 2000)
          }
        }
      })
      .catch(err => {
        let message = this.getTextError(err) // mixins errorHandlerMixins
        if (message !== '') {
          that.$f7.alert(message, this.$t('regles_metier.errors'))
        }
      }).finally(() => {
        that.$f7.hidePreloader()
      })
    },
    accountPicker (e) {
      e.stopPropagation()
      this.accountsPicker.open()
    },
    filesPicker (e) {
      e.stopPropagation()
      // if (this.loadingFile === true || !this.fromCloud) { return }
      this.cloudDocsPicker.open()
    },
    debtorPicker (e) {
      e.stopPropagation()
      if (this.loadingFile === true) { return }
      this.contactsPicker.open()
    },
    addDebtor () {
      if (this.debtorName === '') {
        this.$f7.alert('', 'Debtor name invalid')
        return
      }
      if (this.debtorBank.length > 0) {
        if (validateIBAN(this.debtorBank) === null) {
          this.$f7.alert('', 'Debtor bank invalid')
          return
        }
      }
      if (this.debtorEmail === '') {
        this.$f7.alert('', 'Debtor email invalid')
        return
      }
      this.$engine.services.payments.debtorList.push({
        debtorName: this.debtorName,
        debtorBank: this.debtorBank,
        debtorEmail: this.debtorEmail
      })
      this.debtorName = ''
      this.debtorBank = ''
      this.debtorEmail = ''
    },
    openCreateAttachmentInvoice () {
      loadPage(this, {url: '/attachments/createInvoice/'})
    },
    openImportAttachmentInvoice () {
      let that = this
      that.attachement = ''
      that.attachmentName = ''
      that.attachementReference = ''
      that.attachementId = ''
      that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
      /*
      let that = this
      let buttons1 = [
        {
          text: 'Import from device',
          onClick: function () {
            that.attachement = ''
            that.attachmentName = ''
            that.attachementReference = ''
            that.attachementId = ''
            that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
          }
        },
        {
          text: 'Import from MoneyRoad',
          onClick: function (event, event2) {
            that.attachement = ''
            that.attachmentName = ''
            that.attachementReference = ''
            that.attachementId = ''
            that.filesPicker(event2)
          }
        } */
        // TLV 14/10/2019  : Get Related Invoice est caché pour la démo du 15/10
        /* {
          text: 'Get related invoices',
          onClick: function (event, event2) {
            that.$engine.attachments.getRecommendedList(that.amount, '', that.attachementReference, that.depositExecutionDate)
            .then(response => {
              let filesMap = response.data['recommendationList'].map(function (obj) {
                let rObj = {}
                rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
                return rObj
              })
              let filesMapObj = Object.assign({}, ...filesMap)
              let values = []
              if (Object.keys(filesMapObj).length > 0) {
                values = Object.keys(filesMapObj)
              } else {
                values = ['Nothing found']
              }
              let recommendationListPicker = that.$f7.picker({
                input: '#recommendation-list-input',
                rotateEffect: true,
                cols: [
                  {
                    textAlign: 'center',
                    values: values
                  }
                ],
                onClose: function (p) {
                  if (Object.keys(filesMapObj).length > 0) {
                    if (filesMapObj[p.value].id !== that.attachementId) {
                      that.attachementId = filesMapObj[p.value].id
                      that.cloudFileSel()
                    }
                  }
                },
                onOpen: function (p) {
                  if (Object.keys(filesMapObj).length > 0) {
                    that.attachmentName = p.value
                  }
                }
              })
              recommendationListPicker.open()
            })
            .catch(error => {
              errorMessageAlert(error, that)
            })
          }
        } */
        // ,
        // {
        //   text: 'Get related invoices',
        //   onClick: function (event, event2) {
        //     that.$engine.attachments.getRecommendedList(that.amount, '', that.attachementReference, that.depositExecutionDate)
        //     .then(response => {
        //       let filesMap = response.data['recommendationList'].map(function (obj) {
        //         let rObj = {}
        //         rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
        //         return rObj
        //       })
        //       let filesMapObj = Object.assign({}, ...filesMap)
        //       let values = []
        //       if (Object.keys(filesMapObj).length > 0) {
        //         values = Object.keys(filesMapObj)
        //       } else {
        //         values = ['Nothing found']
        //       }
        //       let recommendationListPicker = that.$f7.picker({
        //         input: '#recommendation-list-input',
        //         rotateEffect: true,
        //         cols: [
        //           {
        //             textAlign: 'center',
        //             values: values
        //           }
        //         ],
        //         onClose: function (p) {
        //           if (Object.keys(filesMapObj).length > 0) {
        //             if (filesMapObj[p.value].id !== that.attachementId) {
        //               that.attachementId = filesMapObj[p.value].id
        //               that.cloudFileSel()
        //             }
        //           }
        //         },
        //         onOpen: function (p) {
        //           if (Object.keys(filesMapObj).length > 0) {
        //             that.attachmentName = p.value
        //           }
        //         }
        //       })
        //       recommendationListPicker.open()
        //     })
        //     .catch(error => {
        //       errorMessageAlert(error, that)
        //     })
        //   }
        // }
        /*
      ]
      let buttons2 = [
        {
          text: 'Cancel',
          color: 'red',
          onClick: function () {
          }
        }
      ]
      this.$f7.actions([buttons1, buttons2]) */
    },
    calendar ($event) {
      /* eslint-disable no-undef */
      let that = this

      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.depositExecutionDate = dateResult
        })
      }
      /* eslint-enable no-undef */
    },
    calendar2 ($event, index) {
      /* eslint-disable no-undef */
      let that = this
      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.multPmts[index].date = dateResult
          // that.Dom7($event.target).val(dateResult)
          that.Dom7($event.target).text(dateResult)
        })
      }
      /* eslint-enable no-undef */
    },
    paymentsDate () {
      if ((this.depositExecutionDate !== undefined) && (this.depositExecutionDate.length > 0)) {
        return this.depositExecutionDate
      } else {
        return 'Select a date'
      }
    },
    getAllInstallmentRules () {
      let that = this
      this.$engine.reglesMetier.get()
      .then(response => {
        const diffAmount = function (a, b) { return parseFloat(a.montant) - parseFloat(b.montant) }
        this.allRules = this.$R.sort(diffAmount, response.data.reglesMetier)
      }).catch(err => {
        errorMessageAlert(err, that)
      })
    },
    setInstallmentRules (event) {
      let id = event.target.value
      if (id) {
        if (id > 0) {
          this.reglesMetier = this.$R.clone(this.allRules.filter(rule => rule.idReglesMetier === id)[0])
        } else {
          let rule = this.$engine.reglesMetier.defaultData()
          rule.idReglesMetier = id
          this.reglesMetier = rule
        }
      } else {
        this.reglesMetier.idReglesMetier = undefined
      }
    },
    intervalleToSec (intervalle) {
      const jours = intervalle.jour === '' ? 0 : parseInt(intervalle.jour)
      const mois = intervalle.mois === '' ? 0 : parseInt(intervalle.mois)
      const annees = intervalle.annee === '' ? 0 : parseInt(intervalle.annee)
      return jours + mois * 30 + annees * 365
    },
    echeanceChanged ($event) {
      this.reglesMetier.nbEcheances = $event
      this.payNumber
      this.reglesMetier.nbEcheances.min
      this.reglesMetier.nbEcheances.max
      if ($event.min <= $event.max) {
        if (this.payNumber < $event.min || this.payNumber > $event.max) {
          this.payNumber = $event.min
        }
      } else {
        this.payNumber = 1
        this.hasInstallments = false
      }
    }
  }
}
</script>
<style>
#cloud-label {
  color: #12bcf1;
  width: 30%;
  background-color: #e6e7e8;
  padding: 3px 3px 3px 3px;
  text-align: center;
  display: inline-block;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #12bcf1;
}
.test-content{
  border-style: solid;
  border-width: 1px;
  border-color: #EBEBED;

	min-height: 15px;

	box-sizing: border-box;
  padding-left: 15px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
}
.test-inner{
  min-height: 15px;
  padding-right: 15px;
  position: relative;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 7px;

  box-sizing: border-box;
  display: flex;
  -webkit-box-flex: 1;

  overflow: hidden;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  align-self: stretch;
}
.test-title{
  color: #0E0144;
  flex-shrink: 1;
  min-width: 0;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.test-after{
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  display: block;
  white-space: nowrap;
  color: #8e8e93;
  flex-shrink: 0;
  margin-left: auto;
  padding-left: 5px;
  max-height: 28px;
}
.grayEmpty{
  background-color: #f7f7f7;
}
.subtitleDebtorList {
  color: #000000;
}
.paymentsRequestSubOption {
  font-size: 14px;
}
.paymentsRequestSubOption input::-webkit-input-placeholder {
  font-size: 14px;
}
.paymentsRequestAddOtherDebtor {
  margin-left: 7px !important;
  float: right !important;
  position: relative !important;
  color: #777777;
}
.negotiateSwitch {
  width: auto !important;
  margin-right: 30px;
}
.formTitle {
  color:white !important;
  text-align: center;
  margin: auto;
}
.facturePart2 {
  color: black;
}
.custom-item-inner {
  width: 100%;
  padding: 8px 15px 7px 0px;
}
.Column50 {
  width: 50% !important;
}
.paymentsButtonLength {
  width: 113px;
}
.button-setting {
  width: 80px;
}
ul {
  margin-left: -35px;
}
</style>



// WEBPACK FOOTER //
// DDCreateTemplate.vue?83f295d6